const LEAFLET_CONTROL_POSITIONS = {
  bottomLeft: "leaflet-bottom leaflet-left",
  bottomRight: "leaflet-bottom leaflet-right",
  topLeft: "leaflet-top leaflet-left",
  topRight: "leaflet-top leaflet-right",
  bottomCenter: "leaflet-bottom"
};

export { LEAFLET_CONTROL_POSITIONS };
